module.exports = __webpack_public_path__ + "media/engagement_responsable/refashion-b3d9e02f.jpg";